import api from "./core";

const basePath = "api/kiosk/Locations";

export default {
  get(id) {
    return api.get(`${basePath}/${id}`);
  }
};
